module.exports = __webpack_public_path__ + "static/img/reward-4.bf07d5ec.png";